export const FilterIds = {
    ADMINS: 'adminsTableFilter',
    COMPANIES: 'companiesTableFilter',
    USERS: 'usersTableFilter',
    CLIENTS: 'clientsTableFilter',
    DOCUMENTS: 'documentsTableFilter',
    CALCULATIONS: 'calculationsTableFilter'
};
